export const buildQuery = (params: any) => {
  params = params || {}
  const query: any[] = []
  Object.keys(params).map(k => {
    if (params[k] || typeof params[k] == 'boolean' || k.includes('_gt'))
      query.push(`${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
  })
  return query.join('&')
}
